// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-d135a67e]:export{siteFontFamily:system-ui,sans-serif,math,ui-rounded,ui-monospce}.item-wrapper__header .title .circle[data-v-d135a67e]{background-color:#3d46f5;border-radius:100%;height:4px;margin-right:5px;width:4px}.item-wrapper__input[data-v-d135a67e]{color:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
